import { render, staticRenderFns } from "./AmostrasStatusCalcinacao.vue?vue&type=template&id=38474a68&"
import script from "./AmostrasStatusCalcinacao.vue?vue&type=script&lang=ts&"
export * from "./AmostrasStatusCalcinacao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports